export default "/_next/static/images/product--articles-af0e372c6b61c8d1f512f0fe038818f4.svg";